import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { Reveal, Eyebrow, PageBand, CTABand, Photo } from "@/components/Shared";
import EnquiryForm from "@/components/EnquiryForm";
import { JOURNAL_POSTS } from "@/data/content";
import { PAGE_HEROES, PHOTOS } from "@/data/photos";

const Journal = () => (
  <>
    <SEO title="Journal | Lumière Aesthetics, Cottesloe" description="Occasional writing from the practice — skin, face, hair, body and practice notes, by the doctors who practise them." />
    <PageBand
      eyebrow="Journal"
      title="Occasional writing from the practice"
      standfirst="Skin, face, hair and body — written by the doctors who treat them. Never noise."
      image={PAGE_HEROES.journal}
    />

    <section className="bg-warm-white" data-testid="journal-index">
      <div className="shell py-24">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {JOURNAL_POSTS.map((post, i) => (
            <Reveal key={post.slug} delay={i * 0.1}>
              <Link to={`/journal/${post.slug}`} data-testid={`journal-card-${post.slug}`} className="card-float block overflow-hidden group h-full">
                <Photo photo={PHOTOS[post.photo]} className="aspect-[16/10]" width={800} />
                <div className="p-7">
                  <Eyebrow>{post.category}</Eyebrow>
                  <h3 className="text-deep-sea mt-2 group-hover:text-sea-green transition-colors duration-300">{post.title}</h3>
                  <p className="text-ink/70 text-sm mt-2 leading-relaxed">{post.excerpt}</p>
                  <p className="text-soft-grey text-xs mt-4">{post.date} · {post.readTime}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>

        <Reveal className="max-w-md mx-auto mt-20 text-center">
          <Eyebrow className="mb-4">Letters</Eyebrow>
          <p className="text-ink/70 text-sm mb-6">Occasional letters from the clinic. Unsubscribe anytime.</p>
          <EnquiryForm type="journal" />
        </Reveal>
      </div>
    </section>

    <CTABand />
  </>
);

export default Journal;
